import api from '@/api_alv'
import Vue from 'vue'
import i18n from '@/assets/i18n/i18n'
import { router } from '@/router.js'

const DIR = 'account/mappings'

// DEFAULTS
const DEFAULT_MAPPING = {
    "id": 0,
    "alvId": "ALV000000000AM",
    "title": null,
    "domain": null,
    "direction": 'import',
    "language": null,
    "maintainer": 'self',
    "versionNumber": null,
    "shareable": "no",
    "source": null,
    "abbreviation": null,
    "fileFormat": "csv",
    "delimiter": null,
    "fileEncoding": null,
    "decimalSeparator": "comma",
    "fileName": null,
    "currency": null,
    "rightsType": null,
    "templateFile": null,
    "sheet": null,
    "headerRow": null,
    "headers": [],
    "dataRow": null,
}

const DEFAULT_COLUMN_MAPPINGS = {
    "id": 0,
    "alvField": null,
    "entityName": null,
    "columnNumber": null,
    "templateColumn": null,
    "skipDuplicates": false,
    "formula": null,
}

// STATE
const state = {

    // Mappings list page
    mappings: [],
    selectedMappings: [],
    azForMappingsImport: [],
    azForMappingsExport: [],
    isAllSelectedMappings: false,
    expandedMappings: [],
    mappingsSssOptions: { // Sss = Server Side Sorting
        sortBy: ['title'],
        sortDesc: [false],
        mustSort: true,
    },
    mappingsFiltersOnRequest: {}, // For determining which filters were last set on load page/search
    
    // Filters & Actions & Buttons
    mappingsSearch: '',
    selectedMappingsAction: [],
    selectedMappingsFileFormatFilter:[],
    
    selectedMappingsDirectionsFilter: [],
    selectedMappingsDomainsFilter: [],
    selectedMappingsMaintainersFilter:[],
    selectedMappingsLanguagesFilter: [],

    usersWithShareable: [],
    lastSelectedAction: null,
    validationMessagesMappings: [],

    // Details
    defaultNewMapping: DEFAULT_MAPPING,
    mappingsUniqueId: '',
    mappingsDetails: {},

    // Dashboard Quicklinks Templates (shared mappings from ALVDIGITAL account)
    quicklinksTemplates: [],

    // Panel: Column Mapping
    mappingsColumnMappings: [],
    selectedColumnMappings: [],
    defaultColumnMappings: DEFAULT_COLUMN_MAPPINGS,
    columnMappingsEditingDialogDetails: DEFAULT_COLUMN_MAPPINGS,
    showColumnMappingsEditingDialog: false,
    columnMappingsHeaders: [],
    columnMappingsDetails: {},
}

// GETTERS
const getters = {
    
    // Mappings List Page
    getMappings                                     (state) { return state.mappings },
    getAzForMappingsImport                          (state) { return state.azForMappingsImport },
    getAzForMappingsExport                          (state) { return state.azForMappingsExport },
    getSelectedMappings                             (state) { return state.selectedMappings },

    getIsAllSelectedMappings                        (state) { return state.isAllSelectedMappings },
    getExpandedMappings                             (state) { return state.expandedMappings },
    getMappingsSssOptions                           (state) { return state.mappingsSssOptions },
    getMappingsFiltersOnRequest                     (state) { return state.mappingsFiltersOnRequest },

    // Filters & Actions & Buttons
    getMappingsSearch                               (state) { return state.mappingsSearch },

    getSelectedMappingsDirectionsFilter             (state) { return state.selectedMappingsDirectionsFilter },
    getSelectedMappingsDomainsFilter                (state) { return state.selectedMappingsDomainsFilter },
    getSelectedMappingsMaintainersFilter            (state) { return state.selectedMappingsMaintainersFilter},
    getSelectedMappingsLanguagesFilter              (state) { return state.selectedMappingsLanguagesFilter },
            
    getSelectedMappingsAction                       (state) { return state.selectedMappingsAction },
    getUsersWithShareable                           (state) { return state.usersWithShareable },
    getLastSelectedAction                           (state) { return state.lastSelectedAction },
    getValidationMessagesMappings                   (state) { return state.validationMessagesMappings },

    // Details  
    getDefaultNewMapping                            (state) { return state.defaultNewMapping },

    getMappingsUniqueId                             (state) { return state.mappingsUniqueId },   
    getMappingsDetails                              (state) { return state.mappingsDetails },
    getMappingsDetailsTitle                         (state) { return state.mappingsDetails.title },
    getMappingsDetailsAlvId                         (state) { return state.mappingsDetails.alvId },
    getMappingsDetailsDomain                        (state) { return state.mappingsDetails.domain },
    getMappingsDetailsDirection                     (state) { return state.mappingsDetails.direction },
    getMappingsDetailsShareable                     (state) { return state.mappingsDetails.shareable },
    getMappingsDetailsMaintainer                    (state) { return state.mappingsDetails.maintainer },
    getMappingsDetailsVersionNumber                 (state) { return state.mappingsDetails.versionNumber },
    getMappingsDetailsNotes                         (state) { return state.mappingsDetails.notes },
    getMappingsDetailsLanguage                      (state) { return state.mappingsDetails.language },
    getMappingsDetailsSource                        (state) { return state.mappingsDetails.source },
    getMappingsDetailsAbbreviation                  (state) { return state.mappingsDetails.abbreviation },
    getMappingsDetailsFileFormat                    (state) { return state.mappingsDetails.fileFormat },
    getMappingsDetailsDelimiter                     (state) { return state.mappingsDetails.delimiter },
    getMappingsDetailsFileEncoding                  (state) { return state.mappingsDetails.fileEncoding },
    getMappingsDetailsDecimalSeparator              (state) { return state.mappingsDetails.decimalSeparator },
    getMappingsDetailsCurrency                      (state) { return state.mappingsDetails.currency },
    getMappingsDetailsRightsType                    (state) { return state.mappingsDetails.rightsType },
    getMappingsDetailsFileName                      (state) { return state.mappingsDetails.fileName },
    getMappingsDetailsTemplateFile                  (state) { return state.mappingsDetails.templateFile },
    getMappingsDetailsSheet                         (state) { return state.mappingsDetails.sheet },
    getMappingsDetailsHeaderRow                     (state) { return state.mappingsDetails.headerRow },
    getMappingsDetailsHeaders                       (state) { return state.mappingsDetails.headers },
    getMappingsDetailsDataRow                       (state) { return state.mappingsDetails.dataRow },
    getMappingsDetailsDownloadPath                  (state) { return state.mappingsDetails.downloadPath },

    // Dashboard Quicklinks Templates
    getQuicklinksTemplates                          (state) { return state.quicklinksTemplates },
    
    //#region Column Mappings PANEL (Getters)
    getColumnMappings                               (state) { return state.mappingsDetails.columnMappings },
    getShowColumnMappingsEditingDialog              (state) { return state.showColumnMappingsEditingDialog },

        getSelectedAccountColumnMappings                (state) { return state.selectedAccountColumnMappings },
        getShowAccountColumnMappingsEditingDialog       (state) { return state.showAccountColumnMappingsEditingDialog },

    getSelectedColumnMappings                       (state) { return state.selectedColumnMappings },   
    getDefaultColumnMappings                        (state) { return state.defaultColumnMappings },
    getDropdownOfHeaders                            (state) { return state.columnMappingsHeaders },

    getColumnMappingsEditingDialogDetails           (state) { return state.columnMappingsEditingDialogDetails },
    getColumnMappingsDetailsEntityName              (state) { return state.columnMappingsEditingDialogDetails.entityName },
    getColumnMappingsDetailsAlvField                (state) { return state.columnMappingsEditingDialogDetails.alvField },
    getColumnMappingsDetailsColumnNumber            (state) { return state.columnMappingsEditingDialogDetails.columnNumber },
    getColumnMappingsDetailsTemplateColumn          (state) { return state.columnMappingsEditingDialogDetails.templateColumn },
    getColumnMappingsDetailsSkipDuplicatesCheckbox  (state) { return state.columnMappingsEditingDialogDetails.skipDuplicates },
    getColumnMappingsDetailsFormula                 (state) { return state.columnMappingsEditingDialogDetails.formula },

    //#endregion
}

// SETTERS
const mutations = {
    // Mappings List Page
    setMappings:                                    (state, value)  => { state.mappings = value},
    setAzForMappingsImport:                         (state, value)  => { state.azForMappingsImport = value},
    setAzForMappingsExport:                         (state, value)  => { state.azForMappingsExport = value},
    setSelectedMappings:                            (state, value)  => { state.selectedMappings = value },

    setIsAllSelectedMappings:                       (state, value)  => { state.isAllSelectedMappings = value },
    setExpandedMappings:                            (state, value)  => { state.expandedMappings = [value] },
    setMappingsSssOptions:                          (state, value)  => { state.mappingsSssOptions = value},
    setMappingsFiltersOnRequest:                    (state, value)  => { state.mappingsFiltersOnRequest = value },
    
    // Filters & Actions & Buttons
    setMappingsSearch:                              (state, value)  => { state.mappingsSearch = value },
    setSelectedMappingsAction:                      (state, value)  => { state.selectedMappingsAction = value},

    setSelectedMappingsDirectionsFilter:            (state, value)  => { state.selectedMappingsDirectionsFilter = value},
    setSelectedMappingsDomainsFilter:               (state, value)  => { state.selectedMappingsDomainsFilter = value},
    setSelectedMappingsMaintainersFilter:           (state, value)  => { state.selectedMappingsMaintainersFilter = value},
    setSelectedMappingsLanguagesFilter:             (state, value)  => { state.selectedMappingsLanguagesFilter = value },
    setUsersWithShareable:                          (state, value)  => { state.usersWithShareable = value },
    setLastSelectedAction:                          (state, value)  => { state.lastSelectedAction = value },
    setValidationMessagesMappings:                  (state,value)   => { state.validationMessagesMappings = value },

    // Details  
    setDefaultNewMapping:                           (state)         => { state.defaultNewMapping = DEFAULT_MAPPING},
    
    setMappingsUniqueId:                            (state, value)  => { state.mappingsUniqueId = value },   
    setMappingsDetails:                             (state, value)  => { state.mappingsDetails = value },
    setMappingsDetailsAlvId:                        (state, value)  => { state.mappingsDetails.alvId = value},
    setMappingsDetailsTitle:                        (state, value)  => { state.mappingsDetails.title = value},
    setMappingsDetailsDomain:                       (state, value)  => { state.mappingsDetails.domain = value},
    setMappingsDetailsDirection:                    (state, value)  => { state.mappingsDetails.direction = value},
    setMappingsDetailsShareable:                    (state, value)  => { state.mappingsDetails.shareable = value},
    setMappingsDetailsMaintainer:                   (state, value)  => { state.mappingsDetails.maintainer = value},
    setMappingsDetailsVersionNumber:                (state, value)  => { state.mappingsDetails.versionNumber = value},
    setMappingsDetailsNotes:                        (state, value)  => { state.mappingsDetails.notes = value},
    setMappingsDetailsLanguage:                     (state, value)  => { state.mappingsDetails.language = value},
    setMappingsDetailsSource:                       (state, value)  => { state.mappingsDetails.source = value},
    setMappingsDetailsAbbreviation:                 (state, value)  => { state.mappingsDetails.abbreviation = value},
    setMappingsDetailsFileFormat:                   (state, value)  => { state.mappingsDetails.fileFormat = value},
    setMappingsDetailsDelimiter:                    (state, value)  => { state.mappingsDetails.delimiter = value},
    setMappingsDetailsFileEncoding:                  (state, value)  => { state.mappingsDetails.fileEncoding = value || null},
    setMappingsDetailsDecimalSeparator:             (state, value)  => { state.mappingsDetails.decimalSeparator = value},
    setMappingsDetailsCurrency:                     (state, value)  => { state.mappingsDetails.currency = value},
    setMappingsDetailsRightsType:                   (state, value)  => { state.mappingsDetails.rightsType = value},
    setMappingsDetailsFileName:                     (state, value)  => { state.mappingsDetails.fileName = value},
    setMappingsDetailsTemplateFile:                 (state, value)  => { state.mappingsDetails.templateFile = value},
    setMappingsDetailsSheet:                        (state, value)  => { state.mappingsDetails.sheet = value },
    setMappingsDetailsHeaderRow:                    (state, value)  => { state.mappingsDetails.headerRow = value },
    setMappingsDetailsHeaders:                      (state, value)  => { state.mappingsDetails.headers = value },
    setMappingsDetailsDataRow:                      (state, value)  => { state.mappingsDetails.dataRow = value },
    setMappingsDetailsDownloadPath:                 (state, value)  => { state.mappingsDetails.downloadPath = value },

    setQuicklinksTemplates:                         (state, value)  => { state.quicklinksTemplates = value },
    
    // Column Mappings Panel (Setters)
    setColumnMappings:                              (state, value)  => { state.mappingsDetails.columnMappings = value },
    setShowColumnMappingsEditingDialog:             (state, value)  => { state.showColumnMappingsEditingDialog = value },
    setSelectedColumnMappings:                      (state, value)  => { state.selectedColumnMappings = value },
    setDropdownOfHeaders:                           (state, value)  => { state.columnMappingsHeaders = value },

    setColumnMappingsEditingDialogDetails:          (state, value)  => { state.columnMappingsEditingDialogDetails = value },
    setColumnMappingsDetailsEntityName:             (state, value)  => { state.columnMappingsEditingDialogDetails.entityName = value },
    setColumnMappingsDetailsAlvField:               (state, value)  => { state.columnMappingsEditingDialogDetails.alvField = value },
    setColumnMappingsDetailsColumnNumber:           (state, value)  => { state.columnMappingsEditingDialogDetails.columnNumber = value },
    setColumnMappingsDetailsTemplateColumn:         (state, value)  => { state.columnMappingsEditingDialogDetails.templateColumn = value },
    setColumnMappingsDetailsSkipDuplicatesCheckbox: (state, value)  => { state.columnMappingsEditingDialogDetails.skipDuplicates = value },
    setColumnMappingsDetailsFormula:                (state, value)  => { state.columnMappingsEditingDialogDetails.formula = value },
}

// ACTIONS
const actions = {

    // FETCH MAPPINGS LIST
    async fetchMappings({ commit, getters }) {  
        commit('setIsLoading', true)
        
        // check for set filters
        let filterObj = {
            'search':       getters.getMappingsSearch,
            'direction':    getters.getSelectedMappingsDirectionsFilter,
            'domain':       getters.getSelectedMappingsDomainsFilter,
            'maintainer':   getters.getSelectedMappingsMaintainersFilter,
            'language':     getters.getSelectedMappingsLanguagesFilter,
        }

        // create string of filter params for api call
        let paramsString = this._vm.$alvPlugin.createApiUrlFilterString(filterObj)

        // sorting options
        let options = getters.getMappingsSssOptions
        let response = await api.getListData2(DIR, getters.getCurrentPage, options.sortBy, options.sortDesc, paramsString)

        // Get list items from DB   
        if(response === undefined || response.error === 1 || response.list.length === 0 ) { 
            commit('setMappings', [])
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
        } else {
            commit('setMappings', response.list)

        }

        commit('setMappingsFiltersOnRequest', filterObj)
        this._vm.$alvPlugin.storePagingInformations(response.filteredRecords, response.currentPage, response.totalRecords)

        commit('setLastSelectedAction', null)
        commit('setIsLoading', false)
    },
    // Fetch shareable import templates from ALVDIGITAL account (maintainer=140) for Dashboard Quicklinks.
    // Hardcoded filters: maintainer=140, shareable=yes, direction=import.
    // Returns the list and commits to a dedicated state slice so the global Mappings list page is untouched.
    async fetchQuicklinksTemplates({ commit }, language) {
        const ALV_MAINTAINER_ID = 140

        let filterObj = {
            'maintainer': ALV_MAINTAINER_ID,
            'shareable':  'yes',
            'direction':  'import',
        }
        if (language) {
            filterObj['language'] = language
        }

        let paramsString = this._vm.$alvPlugin.createApiUrlFilterString(filterObj)
        let response = await api.getListData(DIR, '1', paramsString)

        if (response === undefined || response.error === 1 || !response.list) {
            commit('setQuicklinksTemplates', [])
            return []
        }

        commit('setQuicklinksTemplates', response.list)
        return response.list
    },

    // Fetch mappings by direction and domain
    async fetchMappingsByDomain({commit, getters}) {
        commit('setIsLoading', true)
        
        // check for set filters
        let filterObj = {
            'domain':       getters.getSelectedMappingsDomainsFilter,
        }
        if (getters.getSelectedMappingsDirectionsFilter) {
            filterObj['direction'] = getters.getSelectedMappingsDirectionsFilter
        }
        
        // create string of filter params for api call
        let paramsString = this._vm.$alvPlugin.createApiUrlFilterString(filterObj)

        let response = await api.getListData(DIR, '1', paramsString)

        // Get list items from DB   
        if(response === undefined || response.error === 1 || response.length === 0 ) { 
            commit('setMappings', [])
            commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
        } else {
            commit('setMappings', response.list)
        }

        commit('setIsLoading', false)
    },

    // DETAILS
    // Fetch edit form details 
    async fetchMappingsDetails({ commit, getters, dispatch }, alvId) {
        let values

        // If its a new Mapping set default values for edit form, if not do an details API Call
        if(alvId === 'new') {
            let defaultValues = JSON.parse(JSON.stringify(getters.getDefaultNewMapping)) 
            
            // preset currency to Home Currency
            let userCurrency = getters.getSelectedCurrency.toUpperCase()
            defaultValues.currency = userCurrency

            // Preset mapping language to current user's language when creating a new mapping
            defaultValues.language = i18n.locale

            values = defaultValues
        } else {
            // API Call
            let response = await api.getDetailsById(DIR, alvId)

            // Catch errors
            if (response === undefined || response.length === 0 || response.error === 1) {
                values = {}
            } else {
                values = response
            }
        }

        // Set Mappings detail values
        commit('setMappingsDetails', values)
        dispatch('fetchColumnMappings')

        // Set Panel Values (already in details data, i.e. columnMappings)


        commit('setIsLoading', false)
    },

    // COLUMN MAPPINGS details
    async fetchColumnMappings({ commit, getters }){
        let columnMappings = await getters.getColumnMappings

        if(columnMappings === undefined) return null
        else {
            commit('setIsLoading', false)
            if(columnMappings.length === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
            commit('setColumnMappings', columnMappings)
        }
    },

    // FETCH Users which have at least one shareable mapping
    async fetchUsersWithShareable({ commit, getters }) {
        commit('setIsLoading', true)
        
        let response = await api.getListData(DIR + '/userList', '1')
        // Get list items from DB   
        if(response === undefined || response.error === 1 || response.length === 0 ) { 
            commit('setUsersWithShareable', [])
        } else {
            commit('setUsersWithShareable', response.list)
        }

        commit('setIsLoading', false)
    },

    /** Non-blocking warning when an existing mapping has an uploaded template file
     *  but no column mappings defined. columnMappingsHeaders is the signal that a
     *  template file is present (populated by submitFile and by the MappingsEdit
     *  watcher from mappingsDetails.fileInfo.headerRow).
     *  Has to be re-evaluated whenever the column mappings change, so the alert can
     *  never contradict what the column mappings panel shows.
     */
    refreshNoColumnMappingsWarning({ commit, getters }) {
        let metaData = getters.getMappingsDetails
        let isNew = router.currentRoute.params.alvId == "new"

        let hasUploadedTemplate = getters.getDropdownOfHeaders && getters.getDropdownOfHeaders.length > 0
        let hasNoColumnMappings = !metaData.columnMappings || metaData.columnMappings.length === 0
        let warnNoColumnMappings = metaData.direction == 'import' && !isNew && hasUploadedTemplate && hasNoColumnMappings

        if (warnNoColumnMappings) {
            commit('setValidationMessagesMappings', [{
                type: 'warning',
                msg: i18n.t('lang_ACCOUNT_MAPPINGS_MESSAGE_WARNING_NO_COLUMN_MAPPINGS_DEFINED')
            }])
        } else {
            commit('setValidationMessagesMappings', [])
        }
    },

    // SAVE
    async saveMappingsForm({ commit, getters, dispatch }) {
        commit('setIsLoading', true)
        let alvId = getters.getMappingsDetailsAlvId
        let metaData = getters.getMappingsDetails
        let isNew = router.currentRoute.params.alvId == "new"

        dispatch('refreshNoColumnMappingsWarning')

        // TODO_PT: should not be needed, compare to A-Z Persons > Dealflow => same issue,
        // we send [] and GET returns null
        // FE should send null and not empty array
        // if (Array.isArray(metaData['delimiter']) && metaData['delimiter'].length === 0) {
        //     metaData['delimiter'] = null;
        // }

        // SAVE
        let response = await api.saveEditForm(DIR, alvId, metaData, isNew)

        commit('setIsLoading', false)
        if (response === undefined || response.length === 0 || response.error === 1) {
            // response = []
            commit('setSnackbar', {
                type: 'error',
                msg: this._vm.$alvPlugin.isLangConst(response.response.errorMsg) ? i18n.t(response.response.errorMsg) : response.response.errorMsg
            })
        } else {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_ACCOUNT_MAPPINGS_MESSAGE_SUCCESS_MAPPING_SAVED')
            })
            
            if (isNew) {
                router.push({ name: 'MappingsEdit', params: { alvId: response.response.alvId } })
            }
            await dispatch('fetchMappingsDetails', response.response.alvId)
        }

        commit('setLastSelectedAction', null)
    },

    // Fetch Sources from A-Z
    async fetchAzForMappings({ commit }) {
        let i = await api.getAzForMapping("import")
        commit('setAzForMappingsImport', i.list)
        let e = await api.getAzForMapping("export")
        commit("setAzForMappingsExport", e.list)
    },

    // ACTIONS Switch
    /** Checks if at least 1 work is selected and commit what the action triggers.
     * 	If no work is selected a Dialog is shown. 
     *  If at least 1 work is selected it shows e.g. an specific dialog.
     * @param {Object} commit mutations object from store.
     */
    async doMappingsAction({ commit, getters, dispatch }) {
        if(state.selectedMappings.length > 0) {
            switch(state.selectedMappingsAction) {
                case 'delete':
                    if(state.selectedMappings.length === 1) {
                        commit('setShowDeletionDialog', true)
                    } else {
                        commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_ONLY_ONE') 
                        commit('setShowSelectionRequiredDialog', true)
                    }                    
                    break
                case 'copy':
                    if(state.selectedMappings.length === 1) {
                        dispatch('copyMapping')
                    } else {
                        commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_ONLY_ONE') 
                        commit('setShowSelectionRequiredDialog', true)
                    }
                    break
                case 'adopt':
                    dispatch('adopt')
                    break
                }
        } else {
            commit('setSelectionRequiredText', 'lang_GENERAL_SELECTION_REQUIRED_DIALOG_TEXT_AT_LEAST_ONE') 
            commit('setShowSelectionRequiredDialog', true)	
        } 
    },

    // Action: COPY Mapping
    async copyMapping({ getters, commit, dispatch }) {
        let queryParams = { "action": "copy" }
        let metaData = { "alvIds": getters.getSelectedMappings }

        let response = await api.triggerAction(DIR, metaData, queryParams)

        if(response.error === -1) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERAL_SNACKBAR_COPY_SUCCESSFULL')
            })
            commit('setLastSelectedAction', 'copy')
            router.push({ name: 'MappingsEdit', params: { alvId: response.response.alvId }})
        } else {
            let errorMsg = response.response.errorMsg
            if(errorMsg !== undefined) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
                })
            }
        }
    },

    // Action: DELETE
    async deleteSelectedMappings({ commit, getters, dispatch }) {
        const response = await api.deleteEntries(DIR, getters.getSelectedMappings)
        if(response.error === -1) {        
            for(let i = 0; i < getters.getSelectedMappings.length; i++) {
                let index = getters.getMappings.findIndex(mapping => mapping.alvId == getters.getSelectedMappings[i])
                Vue.delete(getters.getMappings, index)
            }

            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_ENTRY_DELETED')
            })
            
            commit('setSelectedMappings', [])
            commit('setIsAllSelectedMappings', false)
            commit('setSelectedMappingsAction', [])
            dispatch('fetchMappings')
        }
    },

    // Action: ADOPT (copy a third-party-including-ALVDIGITAL mapping to one's own list of mappings)
    async adopt({ getters, commit, dispatch }) {
        let queryParams = { "action": "adopt" }
        let metaData = { "alvIds": getters.getSelectedMappings }

        let response = await api.triggerAction(DIR, metaData, queryParams)

        if(response.error === -1) {
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_MESSAGE_SUCCESS_EXECUTED')
            })
            dispatch('fetchMappings')
        } else {
            let errorMsg = response.response.errorMsg
            if(errorMsg !== undefined) {
                commit('setSnackbar', {
                    type: 'error',
                    msg: this._vm.$alvPlugin.isLangConst(errorMsg) ? i18n.t(errorMsg) : errorMsg
                })
            }
        }
    },

    // DELETE ColumnMapping row
    async deleteSelectedColumnMappings({ getters, commit, dispatch }) {
        let selectedRow = getters.getSelectedColumnMappings 
        let index = getters.getColumnMappings.findIndex(artist => artist.id === selectedRow.id)

        let startAmount = getters.getColumnMappings.length
        Vue.delete(getters.getColumnMappings, index)
        let newAmount = getters.getColumnMappings.length

        if(startAmount > newAmount) {
            commit('setSnackbar', { 
                type: 'success', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL') + '<br />' + i18n.t('lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON'),
                timeout: -1
            })
        } else {
            commit('setSnackbar', { 
                type: 'error', 
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_NOT_SUCCESSFUL'), 
            })
        }

        commit('setSelectedColumnMappings', [])
        if(newAmount === 0) commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
        dispatch('refreshNoColumnMappingsWarning')
    },

}

export default {
    state, getters, actions, mutations
}